import React from 'react';

import ArticleSplitColumns from './article-split-columns.jsx';
import Button from '$partials/ui/button.jsx';
import { formatLinkBlockToUrl } from '$utilities/format.js';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').ArticleListingBlock}
 */
const ArticleListing = ({
    articles,
    automatedArticles,
    ctaLink,
    text,
    title
}) => {
    const listing = articles.length > 0 ? articles.map(item => item.article) : automatedArticles;

    return (
        <section className='col-wrapper-breakout bg-surface-panel-red  rounded-lg'>
            <div className='col-padding py-16'>
                <div className='flex flex-col mb-16'>
                    <h2 className='type-style-sans-h1'>
                        {title}
                    </h2>

                    {text && (
                        <p className='type-style-sans-h3 mt-8 w-full sm:w-5/12'>
                            {text}
                        </p>
                    )}

                    {ctaLink?.linkTo && (
                        <div className='w-full col-padding flex justify-end mt-24 md:mt-16'>
                            <Button
                                as='a'
                                className='button-outcome'
                                href={formatLinkBlockToUrl(ctaLink)}>
                                {'View all'}
                            </Button>
                        </div>
                    )}
                </div>

                <ArticleSplitColumns items={listing} />
            </div>
        </section>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default ArticleListing;
